import React from 'react';
import shopifyLogo from '../assets/shopify_logo.svg';
// TODO: Please update these paths with the correct locations of your logo files.
import wooLogo from '../assets/woo_logo_color.svg';
import codeApi from '../assets/code_api.png';

const Integrations = () => {
  return (
    <section id="integrations" className="py-16 bg-white"> {/* Changed background to white, restored padding */}
      <div className="container mx-auto"> {/* Restored original padding */}
        {/* Titre et sous-titre réinsérés */}
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-2 animate-on-scroll">
          Intégrations
        </h2>
        <p className="section-description animate-on-scroll">
          Intégration facile, sans code ou personnalisée via notre API
        </p>
        
        {/* Bannière "Trusted by" existante */}
        <div className="bg-[#F7F8F9] rounded-xl p-7 md:p-9 animate-on-scroll lg:mx-20">
          <div className="flex flex-col sm:flex-row items-center justify-center text-center sm:text-left">
            <span className="text-lg font-medium text-gray-700 mb-4 sm:mb-0 sm:mr-6 italic">
              S'intègre avec
            </span>
            <div className="w-14 border-t border-gray-300 my-6 sm:w-auto sm:border-t-0 sm:border-l sm:h-14 sm:my-0 sm:ml-4 sm:mr-8"></div>
            <div className="flex flex-wrap justify-center items-center gap-x-6 gap-y-4 sm:gap-x-8 md:gap-x-10 lg:gap-x-12 mt-4 sm:mt-0">
              <a href="https://ouigoo.gitbook.io/ouigoo/integrations/shopify" target="_blank" aria-label="Shopify Integration">
                <img src={shopifyLogo} alt="Shopify" className="h-11 md:h-12 object-contain transition-transform duration-300 ease-in-out hover:scale-110" />
              </a>
              <a href="https://ouigoo.gitbook.io/ouigoo/introduction/ouigoo-api" target="_blank" aria-label="API Integration">
                <img src={codeApi} alt="API" className="h-11 md:h-12 object-contain transition-transform duration-300 ease-in-out hover:scale-110" />
              </a>
              <a href="https://ouigoo.gitbook.io/ouigoo/integrations/woocommerce" target="_blank" aria-label="WooCommerce Integration">
                <img src={wooLogo} alt="WooCommerce" className="h-7 md:h-8 object-contain transition-transform duration-300 ease-in-out hover:scale-110" />
              </a>
            </div>
          </div>
        </div>

        {/* Bouton Commencer l'intégration réinséré */}
        <div className="text-center mt-12 animate-on-scroll"> {/* Ajout d'un margin-top pour l'espacement */}
          <a 
            href="https://ouigoo.gitbook.io/ouigoo"
            target="_blank"
            className="inline-block bg-black text-white px-8 py-4 rounded-lg font-semibold hover:bg-gray-800 transition-colors"
          >
            Commencer l'intégration
          </a>
        </div>
      </div>
    </section>
  );
};

export default Integrations;
